export function openAnotherTab(historyInstance, link) {
  const localHost = window.location.host;
  const isHostedLocal = link.includes(localHost);

  if (isHostedLocal) {
    const route = link.split(localHost)[1];
    historyInstance.push(route);
  } else {
    const win = window.open(link, "_blank");
    win.focus();
  }
}
